import { createFileRoute, redirect } from "@tanstack/react-router";
import { canonicalFeaturePath } from "../../../shared/src/feature-paths";

/**
 * Shop (/shop) is Merch's old address. The site Worker answers a visit with a permanent redirect
 * (shared/src/feature-paths.ts); a link followed inside the site lands on Merch the same way.
 */
export const Route = createFileRoute("/shop/")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: canonicalFeaturePath(location.href), statusCode: 308 });
  },
});
